module.exports = __webpack_public_path__ + "img/80400.884565b9.jpg";